import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';

export class CreditCardQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.CreditCardQualifier';

    public static readonly NAME: string = 'Credit Card Transactions';

    qualificationMethod: string = '';

    minimumTransactionCount: number | null = null;

    minimumTransactionAmount: number | null = null;

    minimumTotalSpend: number | null = null;

    constructor(qual?: IQualifier) {
      super(CreditCardQualifier.CLASS, qual ? qual.id : null);

      if (qual) {
        this.qualificationMethod = (qual as any).qualificationMethod;
        this.minimumTransactionCount = (qual as any).minimumTransactionCount;
        this.minimumTransactionAmount = (qual as any).minimumTransactionAmount;
        this.minimumTotalSpend = (qual as any).minimumTotalSpend;
      }
    }

    getDescription(): string {
      switch (this.qualificationMethod) {
        case 'COUNT':
          return `${this.minimumTransactionCount} CC transaction(s) of at least $${this.minimumTransactionAmount}`;
        case 'SPEND':
          return `$${this.minimumTotalSpend} total CC spend`;
        case 'COUNT_AND_SPEND':
          return `${this.minimumTransactionCount} CC transaction(s) of at least $${this.minimumTransactionAmount} AND $${this.minimumTotalSpend} total CC spend`;
        case 'COUNT_OR_SPEND':
          return `${this.minimumTransactionCount} CC transaction(s) of at least $${this.minimumTransactionAmount} OR $${this.minimumTotalSpend} total CC spend`;
        default:
          return 'Misconfigured Credit Card Qualifier';
      }
    }

    clone(): IQualifier {
      const clone = new CreditCardQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default CreditCardQualifier;
